import { GridCustomCellProps } from '@progress/kendo-react-grid';
import * as React from 'react';
import { parseJSON } from 'date-fns';
import { format } from 'date-fns-tz';
import { ViewModel } from '.';

const NextStopCell = (props: GridCustomCellProps) => {
  const data = props.dataItem as ViewModel;
  return (
    <td {...props.tdProps}>
      {format(parseJSON(data.ScheduledDateTime), 'LL/dd/yyyy HH:mm zzz')}<br />
      {data.Verb}
    </td>
  );
}
export default React.memo(NextStopCell, (prev, next) => prev.dataItem.Hash === next.dataItem.Hash);